import { Component, Input } from '@angular/core';

import {
  DividerComponent,
  FileSizePipe,
  IconComponent,
  SpinnerComponent,
} from '@core/user-interface-legacy';

import type { AttachmentPlaceloader } from './attachment-placeloader.types';
@Component({
  selector: 'rt-attachment-placeloader',
  templateUrl: 'attachment-placeloader.component.html',
  styleUrls: [
    '../attachment-item/attachment-item.component.less',
    './attachment-placeloader.component.less',
  ],
  imports: [DividerComponent, FileSizePipe, IconComponent, SpinnerComponent],
})
export class AttachmentPlaceloaderComponent {
  @Input() public attachmentPlaceloader: AttachmentPlaceloader;
}
